import { ref, type Ref } from 'vue';

/**
 * The suite-wide "ask assistant-api again" signal for the Lumi launcher
 * (issue 364 F29).
 *
 * LumiDock resolves availability per tenant + person, which covers a tenant
 * SWITCH on its own. What it cannot see from inside is a write that changes the
 * answer for the tenant already on screen: the workspace's own AI switch lives
 * on the Billing page, in a different app-kit consumer, and before this the
 * launcher only caught up on a full page reload.
 *
 * One monotonic counter, deliberately: the dock keys its lookup on it, so
 * bumping it re-runs the SAME fail-closed resolution (unmount, ask, mount only
 * on a definite yes) rather than letting a call site push an availability value
 * of its own — a caller that could assert "AI is on" would be exactly the kind
 * of control that reports a state the system may not deliver.
 *
 * Module-scoped state, like the notice/toast singletons in this kit: one signal
 * per app instance, no registration, and nothing to tear down.
 */
const availabilityVersion: Ref<number> = ref(0);

/** Re-resolve Lumi availability wherever a dock is mounted. */
export function refreshLumiAvailability(): void {
  availabilityVersion.value += 1;
}

/** The signal itself, for the dock's watch key. Read-only by convention. */
export function lumiAvailabilityVersion(): Ref<number> {
  return availabilityVersion;
}
